(function () {
  if (window.__RE_UNITS_TOGGLE__) return; window.__RE_UNITS_TOGGLE__ = true;

  var TO_IN = 1/2.54, PREC = 1, doc = document,
      RE_UNIT=/\s*(cm|in)$/i,
      RE_RANGE=/^(\d+(?:\.\d+)?)\s*[–-]\s*(\d+(?:\.\d+)?)$/, RE_LT=/^<\s*(\d+(?:\.\d+)?)$/, RE_NUM=/^(\d+(?:\.\d+)?)$/;

  // A) root scope: run anywhere; we only init when markup exists
var ROOT = document;

// B) click delegate: no template prefix
document.addEventListener('click', function(e){
  var btn = e.target.closest && e.target.closest('.re-unit-toggle [data-unit]');
  if (!btn) return;
  e.preventDefault();
  var toggle = btn.closest('.re-unit-toggle');
  var table  = toggle ? findTableForToggle(toggle) : null;
  if (!table) return;
  render(btn.getAttribute('data-unit'), table, toggle);
});

  function pow10(n){var p=1;while(n--)p*=10;return p} var F=pow10(PREC);
  function fmt(n){var s=(Math.round(n*F)/F).toString();return s.replace(/\.0$/,'')}
  function parse(txt){txt=(txt||'').toString().trim().replace(RE_UNIT,'');var m;
    if((m=txt.match(RE_RANGE)))return{t:'range',a:+m[1],b:+m[2]};
    if((m=txt.match(RE_LT   )))return{t:'lt',a:+m[1]};
    if((m=txt.match(RE_NUM  )))return{t:'num',a:+m[1]};
    return{t:'raw',raw:txt}}
  function toUnit(txt,unit){var p=parse(txt),conv=unit==='in'?function(v){return v*TO_IN}:function(v){return v};
    if(p.t==='raw')return p.raw+(unit?' '+unit:'');
    if(p.t==='lt')return '< '+fmt(conv(p.a))+' '+unit;
    if(p.t==='range')return fmt(conv(p.a))+'–'+fmt(conv(p.b))+' '+unit;
    return fmt(conv(p.a))+' '+unit}

  var initedToggles=new WeakSet();

  function withinRoot(node){
    return ROOT === doc ? true : !!(node && (node===ROOT || ROOT.contains(node)));
  }

  function findTableForToggle(toggle){
    // forward siblings
    var el=toggle.nextElementSibling;
    while(el && withinRoot(el)){
      if(el.matches && el.matches('.re-sizeblock')) return el;
      if(el.querySelector){ var q=el.querySelector('.re-sizeblock'); if(q) return q; }
      el=el.nextElementSibling;
    }
    // upward, stop at ROOT
    var p=toggle.parentElement;
    while(p && p!==doc.body && withinRoot(p)){
      var first=p.querySelector('.re-sizeblock'); if(first) return first;
      p=p.parentElement;
    }
    return null;
  }

  function cacheRaw(table){
    if(!table) return;
    var cells=table.querySelectorAll('.re-unit');
    for(var i=0;i<cells.length;i++){
      var td=cells[i];
      if(!td.dataset.reRaw){
        td.dataset.reRaw=(td.textContent||'').trim().replace(RE_UNIT,'');
      }
    }
  }

  function setPillStateGroup(toggle,unit){
    var pills=toggle.querySelectorAll('[data-unit]');
    for(var i=0;i<pills.length;i++){
      var el=pills[i];
      var active=el.getAttribute('data-unit')===unit;
      if(active) el.classList.add('is-active'); else el.classList.remove('is-active');
    }
  }

  function render(unit,table,toggle){
    if(table){
      var cells=table.querySelectorAll('.re-unit');
      for(var i=0;i<cells.length;i++){
        var td=cells[i];
        if(td.dataset.reRaw){ td.textContent=toUnit(td.dataset.reRaw,unit); }
      }
    }
    if(toggle) setPillStateGroup(toggle,unit);
    requestNudge();
  }

  var nudgeScheduled=false;
  function requestNudge(){
    if(nudgeScheduled) return; nudgeScheduled=true;
    requestAnimationFrame(function(){
      nudgeScheduled=false;
      var toggles=ROOT.querySelectorAll('.re-unit-toggle');
      for(var i=0;i<toggles.length;i++){
        var t=toggles[i], label=t.querySelector('span'), pill=t.querySelector('[data-unit]');
        if(!label || !pill) continue;
        var lh=label.getBoundingClientRect().height||0;
        var ph=pill.getBoundingClientRect().height||0;
        var d=Math.round((ph-lh)/2);
        label.style.transform='translateY('+d+'px)';
      }
    });
  }

  function initToggle(toggle){
    if(!toggle || initedToggles.has(toggle) || !withinRoot(toggle)) return false;
    var table=findTableForToggle(toggle); if(!table) return false;
    cacheRaw(table);
    var defUnit=(toggle.dataset && toggle.dataset.default ? toggle.dataset.default : 'cm').toLowerCase();
    render(defUnit,table,toggle);
    initedToggles.add(toggle);
    return true;
  }

  function initAll(scope){
    var any=false;
    var base = scope && withinRoot(scope) ? scope : ROOT;
    var list = base.querySelectorAll('.re-unit-toggle');
    for(var i=0;i<list.length;i++){ any = initToggle(list[i]) || any; }
    return any;
  }

  var resizeQueued=false;
  function onResize(){ if(resizeQueued) return; resizeQueued=true;
    requestAnimationFrame(function(){ resizeQueued=false; requestNudge(); });
  }

  var mo, observeQueued=false;
  function onMutations(){ if(observeQueued) return; observeQueued=true;
    Promise.resolve().then(function(){ observeQueued=false; initAll(); });
  }

  function start(){
    if(!mo){
      mo = new MutationObserver(function(muts){
        // only react if added nodes touch ROOT
        for(var i=0;i<muts.length;i++){
          var m=muts[i];
          for(var j=0;j<(m.addedNodes?m.addedNodes.length:0);j++){
            var n=m.addedNodes[j];
            if(n.nodeType===1 && withinRoot(n)){ onMutations(); return; }
          }
        }
      });
      mo.observe(ROOT, { childList:true, subtree:true });
    }
    initAll();
    requestNudge();
  }

  // Clicks only inside product template
  doc.addEventListener('click',function(e){
    var btn = e.target.closest && e.target.closest('.template-product .re-unit-toggle [data-unit]');
    if(!btn) return;
    e.preventDefault();
    var toggle = btn.closest('.re-unit-toggle');
    var table  = toggle ? findTableForToggle(toggle) : null;
    if(!table) return;
    render(btn.getAttribute('data-unit'), table, toggle);
  });

  doc.addEventListener('shopify:section:load', start);
  if(doc.fonts && doc.fonts.ready) doc.fonts.ready.then(requestNudge);
  window.addEventListener('load', requestNudge, { passive:true });
  window.addEventListener('resize', onResize, { passive:true });

  if(doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
  if('requestIdleCallback' in window){ requestIdleCallback(start, { timeout:1200 }); } else { setTimeout(start, 400); }
})();
